﻿$.fn.dxCtrlContentEnvoiMailingEnvoyer = function custom_dxCtrlContentEnvoiMailingEnvoyer(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingenvoyer dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingEnvoyer(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingEnvoyer = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        //if (option.type == "sms" || option.type == "mobile") {
        //    $("<div style='margin:5px'/>").appendTo(container).dxCtrlWarningForm({
        //        type: "error",
        //        html: function () {
        //            return "<div style='font-size:80%;'>" +
        //                "Merci de vous assurer que les messages que vous comptez envoyer respectent la législation en cours sur le territoire français et international en prohibant, sans que cette liste soit limitative :<br/><br/>" +
        //                "tout contenu à caractère raciste, antisémite, xénophobe, révisionniste, pornographique, menaçant, injurieux, violent ou portant atteinte d'une quelconque manière à l'ordre public et la dignité humaine,l'incitation à la consommation de substances interdites, l'encouragement à la violence, la réalisation de crimes et délits,tout acte délictueux, fraude et escroquerie,toute utilisation ou transmission de virus informatiques, codes ou programmes ayant pour objectif d'infecter, prendre le contrôle ou interagir avec tout téléphone, tablette, ordinateur ou logiciel.<br/><br/>" +
        //                "Sont aussi interdites toutes campagnes:<br/>" +
        //                " &bull; de nature politique ou religieuse<br/>" +
        //                " &bull; en vue de la réalisation d'économies d'énergie ou de la production d'énergies renouvelables<br/>" +
        //                " &bull; en rapport avec le CPF<br/>" +
        //                "</div>"
        //        }
        //    })
        //}

        if (option.type == "email") {
            var $DivVerifEmail = $("<div style='margin-bottom:5px;'/>").appendTo(container)
            //gestion des vérifications de mails
            var lstFinal = option.clComDest.mGetLstDestComNettoyer()
            if (lstFinal.length > 100) {
                option.bddCtrl.mAjaxCall({
                    command: "getadresseemailnotverifiedfromcomemailenvoi",
                    id_com_email_envoi: option.data.id_com_email_envoi
                },
                    function (data) {
                        if (typeof data.lstemail == 'undefined') data.lstemail = []
                        data.lstemail = data.lstemail.filter(function (o) { return lstFinal.filter(function (oo) { return o.adresse_email == oo.adresse_email }).length > 0 })
                        var percent = (data.lstemail.length / lstFinal.length * 100).toFixed(0)
                        if (data.lstemail.length > 1) {
                            $DivVerifEmail.css("border-bottom", theme.border)
                            var $TableVerif = $("<table style='width:100%;" + ((percent > 20) ? "color:red;" : ((percent > 10) ? "color:orange;" : "")) + "'/>").appendTo($DivVerifEmail)
                            var $TrVerif = $("<tr/>").appendTo($TableVerif)
                            var $TdVerif = $("<td style='width:100%;padding-right:5px;padding-bottom:5px;line-height:1;'/>").appendTo($TrVerif)
                            $("<div style='font-weight:bold;font-size:120%;'><span style='font-size:180%'>" + percent + "%</span> (" + data.lstemail.length + " adresses emails) non vérifiées.</div>").appendTo($TdVerif)
                            if (percent >= 0) {
                                $("<div style='opacity:0.8;'>Il est recommandé d'effectuer une vérification pour éviter un passage en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/Qu_est_ce_qu_un_envoi_degrade/bc' target='_blank'>envoi dégradé</a>.</div>").appendTo($TdVerif)
                                $("<div style='font-size:80%;font-style:italic;opacity:0.8;'>Lorsqu’une adresse est vérifiée, elle est considérée comme sûre et n’a plus besoin d’être vérifiée à nouveau. <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/52/Verifier_vos_adresses_emails/bc' target='_blank'>en savoir plus</a></div>").appendTo($TdVerif)
                            }
                            var $TdVerif = $("<td style='width:1px;'/>").appendTo($TrVerif)
                            $("<div style='margin:5px 0;'/>").appendTo($TdVerif).dxCtrlButton({
                                html: "Vérifier<br/>les emails",
                                width: 130,
                                onClick: function (e) {
                                    if (option.bddCtrl.isDemo) {
                                        mNotify("Vous êtes dans un environnement de démo.<br/>Vous ne pouvez pas lancer un test des adresses emails.", "warning", 6000)
                                    } else {
                                        var exe = new cVerifAdresseEmail(option.bddCtrl, data.lstemail, {
                                            onClose: function () {
                                                if (typeof option.onDemandeUpdateDest != 'undefined') option.onDemandeUpdateDest()
                                            }
                                        })
                                        exe.mExe()
                                        //$("<div/>").appendTo("body").dxCtrlAchatPopup({
                                        //    bddCtrl: option.bddCtrl,
                                        //    typeProduit: "credit_test_adresse_email",
                                        //    nb: data.lstemail.length,
                                        //    onPaiement: function () {
                                        //        option.bddCtrl.objCptCli.data.nb_credit_test_adresse_email = data.lstemail.length
                                        //        jaugeDemarrage.mHide()

                                        //        var txtEmail = ""
                                        //        data.lstemail.forEach(function (email) { txtEmail += ((txtEmail.length > 0) ? "," : "") + email.adresse_email })
                                        //        $("<div/>").appendTo("body").dxCtrlPopupVerifEmail({
                                        //            bddCtrl: option.bddCtrl,
                                        //            lstAdresseEmail: txtEmail,
                                        //            onClose: function () {
                                        //                mConstruit()
                                        //            }
                                        //        })
                                        //    }
                                        //})
                                    }
                                }
                            })
                        }
                    })
            }

        }

        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)

        var $DivTailleMsgLib = $("<div style='white-space:nowrap;text-align:left;opacity:0.2;'>Taille de votre message</div>").appendTo($Td)
        var $DivTailleMsg = $("<div style='white-space:nowrap;text-align:left;font-size:200%;'></div>").appendTo($Td)
        switch (option.type) {
            case "email":
                $DivTailleMsg.html((option.data.heberger_image == "1") ? option.data.taille_octet_ss_image.sizeFile(2) : option.data.taille_octet.sizeFile(2))
                break;
            case "sms":
                var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                $DivTailleMsg.html(sendSms.mGetNbCaractereMessage(option.data.tracking == "1") + " car./" + sendSms.mGetNbCredit1MessageFrance(option.data.tracking == "1") + " sms")
                break;
            default: break;
        }

        var nbCredit = 0
        var $DivNbCredit1MsgLib = $("<div style='white-space:nowrap;text-align:left;opacity:0.2;margin-top:10px;'>Nombre de crédit pour 1 message</div>").appendTo($Td)
        var $DivNbCredit1Msg = $("<div style='white-space:nowrap;text-align:left;font-size:200%;'></div>").appendTo($Td)
        switch (option.type) {
            case "email":
                var taille = ((option.data.heberger_image == "1") ? option.data.taille_octet_ss_image : option.data.taille_octet)
                nbCredit = Math.ceil(taille / 1024 / 256)
                $DivNbCredit1Msg.html(nbCredit + " crédit" + ((nbCredit > 1) ? "s" : ""))
                break;
            case "sms":
                $DivNbCredit1MsgLib.text("Nombre de crédit pour 1 message (France)")
                var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                nbCredit = sendSms.mGetNbCredit1Message("fr", option.data.tracking == "1")
                $DivNbCredit1Msg.html(nbCredit + " crédit" + ((nbCredit > 1) ? "s" : ""))
                break;
            default: break;
        }

        var nbTotalCredit = 0
        var $DivNbCreditNMsgLib = $("<div style='white-space:nowrap;text-align:left;opacity:0.2;margin-top:10px;'>Nombre total de crédits</div>").appendTo($Td)
        var $DivNbCreditNMsgLib = $("<div style='white-space:nowrap;text-align:left;opacity:0.2;'>pour " + option.clComDest.mGetLstDestComNettoyer().length + " destinataires</div>").appendTo($Td)
        var $DivNbCreditNMsg = $("<div style='white-space:nowrap;text-align:left;font-size:200%;'></div>").appendTo($Td)
        switch (option.type) {
            case "email":
                nbTotalCredit = nbCredit * option.clComDest.mGetLstDestComNettoyer().length
                $DivNbCreditNMsg.html(nbTotalCredit + " crédit" + ((nbCredit > 1) ? "s" : ""))
                break;
            case "sms":
                var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                option.clComDest.mGetLstDestComNettoyer().forEach(function (comDest) {
                    comDest.nb_credit_par_message = sendSms.mGetNbCredit1Message(comDest.tel_code_pays, option.data.tracking == "1")
                })
                var lstNb = option.bddCtrl.getObjet(option.data).objetMetier.mGetRepartCreditParCodePays(option.clComDest.mGetLstDestComNettoyer())
                $DivNbCreditNMsg.css("font-size", "100%")
                if (lstNb.length > 0) {
                    $("<div>Détail des crédits par pays</div>").appendTo($DivNbCreditNMsg)
                    var $DivDetailCredit = $("<div style='max-height:200px;overflow:auto;'/>").appendTo($DivNbCreditNMsg)
                    var $TableDetailCredit = $("<table style='margin-top:10px;font-family:barlow condensed;'/>").appendTo($DivDetailCredit)
                    var $TrDetailCredit = $("<tr style='line-height:0.8;text-align:center;vertical-align:bottom;font-size:90%;'/>").appendTo($TableDetailCredit)
                    var $TdPays = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Pays</td>").appendTo($TrDetailCredit)
                    var $TdUnitaire = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Nb crédit<br/>unitaire</td>").appendTo($TrDetailCredit)
                    var $TdNbComDest = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Nb<br/>destinataires</td>").appendTo($TrDetailCredit)
                    var $TdTotal = $("<td style='padding:0 5px;opacity:0.3;text-align:right;'>Total</td>").appendTo($TrDetailCredit)
                    lstNb.forEach(function (nb) {
                        var $TrDetailCredit = $("<tr/>").appendTo($TableDetailCredit)
                        var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == nb.code_pays })[0]
                        var $TdPays = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;'><table><tr><td><img src='https://flagcdn.com/w20/" + nb.code_pays.toLowerCase() + ".png' style='padding-right:5px;padding-top:5px;'/></td><td>" + indicatif.name + "</td></tr></td>").appendTo($TrDetailCredit)
                        var $TdUnitaire = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";text-align:center;padding:0 5px;'>" + nb.nb_credit + "</td>").appendTo($TrDetailCredit)
                        var $TdNbComDest = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";text-align:center;padding:0 5px;'>" + nb.lstComDest.length + "</td>").appendTo($TrDetailCredit)
                        var $TdTotal = $("<td style='padding:0 5px;text-align:right;'>" + (nb.nb_credit * nb.lstComDest.length) + "</td>").appendTo($TrDetailCredit)
                        nbTotalCredit += (nb.nb_credit * nb.lstComDest.length)
                    })
                }

                var $TableTot = $("<table/>").appendTo($Td)
                var $TrTot = $("<tr/>").appendTo($TableTot)
                var $TdTot = $("<td style='width:100%;white-space:nowrap;font-size:140%;text-align:left;'>Total: <b style='font-size:120%;'>" + nbTotalCredit + "</b> crédits SMS</td>").appendTo($TrTot)
                var $TdTot = $("<td style='width:1px;padding-left:5px;'></td>").appendTo($TrTot)
                $("<div/>").appendTo($TdTot).dxCtrlButton({
                    icon: 'fas fa-hand-holding-dollar',
                    txtTooltip: "Détails des prix SMS par pays",
                    onClick: function (e) {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            width: 250,
                            target: e.component.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "15px")
                                var sendSms = new cSendSms(option.bddCtrl)
                                sendSms.mGetDivTarifSmsParPays(contentElement)
                            }
                        }).dxCtrlTooltip("instance")
                        tt.show()
                    }
                })
                break;
            default: break;
        }

        var nbCreditDispo = 0
        switch (option.type) {
            case "email":
                nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbEmailDispo()
                break;
            case "sms":
                nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbSmsDispo()
                break;
            default: break;
        }

        var $Td = $("<td style='width:100%;vertical-align:bottom;font-family:barlow condensed;'/>").appendTo($Tr)

        var envoiKoMessage = ""
        switch (option.type) {
            case "email":
                if (option.data.nom_usuel_expediteur != null && option.data.nom_usuel_expediteur.length > 0) {
                    $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:5px;'></i> Votre nom usuel est <b>" + option.data.nom_usuel_expediteur + "</b>.</div>").appendTo($Td)
                } else {
                    envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Vous devez définir votre nom usuel"
                    $("<div style='text-align:right;padding:5px 0;color:red;' class='state-hover'><i class='fas fa-thumbs-down' style='font-size:140%;padding-right:5px;'></i> Vous devez définir votre nom usuel.</div>").appendTo($Td).on("click", function () {
                        option.onDemandeExpediteur()
                    })
                }
                //on avait le test (option.data.email_expediteur != parametre.adresseEmailNePasRepondre) compredn pas pourquoi 14/09/2024
                //if (option.data.email_expediteur != null && option.data.email_expediteur.length > 0 && option.data.email_expediteur != parametre.adresseEmailNePasRepondre) {
                if (option.data.email_expediteur != null && option.data.email_expediteur.length > 0) {
                    $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vos correspondants vous répondrons sur l'adresse email <u style='font-size:80%;'>" + option.data.email_expediteur + "</u>.</div>").appendTo($Td)
                } else {
                    envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Vous devez définir votre adresse email d'envoi"
                    $("<div style='text-align:right;padding:5px 0;color:red;' class='state-hover'><i class='fas fa-thumbs-down' style='font-size:140%;padding-right:0px;'></i> Vous devez définir votre adresse email d'envoi.</div>").appendTo($Td).on("click", function () {
                        option.onDemandeExpediteur()
                    })
                }
                break;
            case "sms":
                if (option.data.emetteur != null && option.data.emetteur.length > 0) {
                    $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Votre message sera envoyé avec l'identité <b>" + option.data.emetteur + "</b>.</div>").appendTo($Td)
                } else {
                    $("<div style='text-align:right;padding:5px 0;color:orange;' class='state-hover'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Votre message sera envoyé avec l'identité <b>" + parametre.nom + "</b>.</div>").appendTo($Td).on("click", function () {
                        option.onDemandeExpediteur()
                    })
                }
                break;
        }

        //lien de désinscription
        //lien d'ouverture dans navigateur
        switch (option.type) {
            case "email":
                var $DivDesinscription = $("<div/>").appendTo($Td)
                option.bddCtrl.mAjaxCall({
                    command: "gethtmlurldataemailbdd",
                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                    id: option.bddCtrl.getObjet(option.data).cle()
                }, function (data) {
                    if (parametre.code_appli == "ppmasc" || option.bddCtrl.nom_base.endsWith("_aagest")) {
                        //nouvelle version
                        var rgpd = new cRgpd({ html: data.html, data: option.data })
                        if (rgpd.isOkRgpd()) {
                            if (option.data.rgpd_is_email_commercial == "0") {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Votre message n'est pas commercial (hors RGPD).</div>").appendTo($DivDesinscription)
                            } else {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Votre message est conforme à la RGPD.</div>").appendTo($DivDesinscription)
                            }
                        } else {
                            var $DivRgpd = $("<div class='state-hover'/>").appendTo($DivDesinscription)
                            if (rgpd.isOkLienDesinscription()) {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un lien de désinscription.</div>").appendTo($DivRgpd)
                            } else {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-down' style='color:red;font-size:140%;padding-right:0px;'></i> Vous n'avez pas de lien de désinscription.</div>").appendTo($DivRgpd)
                            }
                            if (rgpd.isOkLienPixelTracking()) {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un lien de désactivation du pixel de suivi.</div>").appendTo($DivRgpd)
                            } else {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-down' style='color:red;font-size:140%;padding-right:0px;'></i> Vous n'avez pas de lien de désactivation du pixel de suivi.</div>").appendTo($DivRgpd)
                            }
                            if (rgpd.isOkChampNomSociete()) {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un champ pour le nom de la société expéditrice.</div>").appendTo($DivRgpd)
                            } else {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-down' style='color:red;font-size:140%;padding-right:0px;'></i> Vous n'avez pas de champ pour le nom de la société expéditrice.</div>").appendTo($DivRgpd)
                            }
                            if (rgpd.isOkLienPolitiqueConf()) {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un lien sur votre politique de confidentialité.</div>").appendTo($DivRgpd)
                            } else {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-down' style='color:red;font-size:140%;padding-right:0px;'></i> Vous n'avez pas de lien sur votre politique de confidentialité.</div>").appendTo($DivRgpd)
                            }
                            if (rgpd.isOkChampSourceEmail()) {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un champ pour la source de l'adresse email.</div>").appendTo($DivRgpd)
                            } else {
                                $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-down' style='color:red;font-size:140%;padding-right:0px;'></i> Vous n'avez pas de lien sur la source de l'adresse email.</div>").appendTo($DivRgpd)
                            }
                            $DivRgpd.on("click", function () {
                                option.onDemandeRgpd()
                            })
                            envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Votre message n'est pas conforme à la RGPD"
                        }
                    } else {
                        //ancienne version
                        if (data.html.contains('class="AViewBrowser"')) {
                            $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un lien pour consulter votre message en ligne.</div>").appendTo($DivDesinscription)
                        } else {
                            $("<div style='text-align:right;padding:5px 0;color:orange;line-height:1;'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Vous n'avez pas de lien pour consulter votre message en ligne.<br/><a href='" + parametre.url_cognoss + "/0/83/Lien_de_desinscription_et_de_navigation/bc' target='_blank' style='font-size:80%;'>Comment ajouter un lien de navigation</a></div>").appendTo($DivDesinscription)
                        }
                        if (data.html.contains("{LIEN_DESINSCRIPTION}")) {
                            $("<div style='text-align:right;padding:5px 0px;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un lien pour se désincrire.</div>").appendTo($DivDesinscription)
                        } else {
                            $("<div style='text-align:right;padding:5px 0px;color:orange;line-height:1;'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Vous n'avez pas de lien pour permettre à votre destinataire de se désincrire.<br/><a href='" + parametre.url_cognoss + "/0/83/Lien_de_desinscription_et_de_navigation/bc' target='_blank' style='font-size:80%;'>Comment ajouter un lien de désinscription</a></div>").appendTo($DivDesinscription)
                        }
                    }
                })
                break;
            case "sms":
                break;
        }

        if (option.clComDest.mGetGardeListeNoire()) {
            $("<div style='text-align:right;padding:5px 0;color:orange;' class='state-hover'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Vous avez décidé de garder les destinataires désinscrits.</div>").appendTo($Td).on("click", function () {
                option.onDemandeDestinataire()
            })
        }

        if (option.clComDest.mGetLstDestComNettoyer().length > 0) {
            $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez <b>" + option.clComDest.mGetLstDestComNettoyer().length + "</b> destinataires.</div>").appendTo($Td)
        } else {
            envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Aucun destinataire pour votre message"
            $("<div style='text-align:right;padding:5px 0;color:red;' class='state-hover'><i class='fas fa-thumbs-down' style='font-size:140%;padding-right:0px;'></i> Aucun destinataire pour votre message.</div>").appendTo($Td).on("click", function () {
                option.onDemandeDestinataire()
            })
        }

        switch (option.type) {
            case "email":
                if (option.data.objet != null && option.data.objet.length > 0) {
                    $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un objet saisie pour votre email.</div>").appendTo($Td)
                } else {
                    envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Vous n'avez pas saisie d'objet pour votre email"
                    $("<div style='text-align:right;padding:5px 0;color:red;' class='state-hover'><i class='fas fa-thumbs-down' style='font-size:140%;padding-right:0px;'></i> Vous n'avez pas saisie d'objet pour votre email.</div>").appendTo($Td).on("click", function () {
                        option.onDemandeObjet()
                    })
                }
                if (option.data.is_empty_on_init == "0") {
                    $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un contenu pour votre email.</div>").appendTo($Td)
                } else {
                    $("<div style='text-align:right;padding:0px;'><i class='fas fa-thumbs-down' style='color:red;font-size:140%;padding-right:0px;'></i> Vous n'avez pas de contenu pour votre email.</div>").appendTo($Td)
                    envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Vous n'avez pas de contenu pour votre email"
                }
                break;
            case "sms":
                if (option.data.body_txt != null && option.data.body_txt.length > 0) {
                    $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:green;font-size:140%;padding-right:0px;'></i> Vous avez un contenu pour votre sms.</div>").appendTo($Td)
                } else {
                    envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Votre sms est vide"
                    $("<div style='text-align:right;padding:5px 0;color:red;'><i class='fas fa-thumbs-down' style='font-size:140%;padding-right:0px;'></i> Votre sms est vide.</div>").appendTo($Td)
                }
                break;
        }

        if (option.type == "email" && option.bddCtrl.baseAppli.para.add_pub_on_emailenvoi_with_1_ligne_credit) {
            if (option.bddCtrl.mGetArray("credit_email").length == 1) {
                var $DivBadge = $("<div style='text-align:right;padding:5px 0;'><i class='fas fa-thumbs-up' style='color:orange;font-size:140%;padding-right:0px;'></i> Un badge de parrainage <b>" + parametre.nom + "</b> sera automatiquement ajouté à la fin de votre email.<br/>Pour supprimer ce bagde, vous pouvez </div>").appendTo($Td)
                var $A = $("<a href='javascript:void(0)'>Acheter des crédits</a>").appendTo($DivBadge)
                $A.on("click", function () {
                    $("<div/>").appendTo("body").dxCtrlAchatPopup({
                        bddCtrl: option.bddCtrl,
                        typeProduit: ((option.type == "email") ? "credit_email" : "credit_sms"),
                        nb: ((option.type == "email") ? 1000 : 5),
                        onPaiement: function () {
                            jaugeDemarrage.mShow()
                            option.bddCtrl.mReloadTable(((option.type == "email") ? "credit_email" : "credit_sms"), function () {
                                mConstruit()
                                jaugeDemarrage.mHide()
                            })
                        }
                    })
                })
            }
        }

        //var cad = new cCadencementEnvoi(option.data)
        //var txt = cad.mGetLibelle()
        //if (txt.length > 0) {
        //    var $DivResume = $("<div style='text-align:right;padding:0px;color:orange;'>Une plannification de vos envois est définie.<br/>" + txt + "</div>").appendTo($Td)
        //}

        //pub email
        if (option.bddCtrl.objCptCli.objetMetier.mHasPubEmail()) {
            var $Table = $("<table style='margin:5px 0;'/>").appendTo($Td)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdPub = $("<td style='width:100%'/>").appendTo($Tr)
            if (option.bddCtrl.objCptCli.data.offre_essai == "1" && parametre.type_gestion_environnement == "abonnement") {
                //en essai
                $TdPub.html("le logo <b>'Envoyé avec " + parametre.nom + "'</b> sera ajouté à la fin de vos emails. Vous pouvez vous abonner pour pouvoir retirer ce logo.")
            } else {
                $TdPub.html("le logo <b>'Envoyé avec " + parametre.nom + "'</b> sera ajouté à la fin de vos emails.")
                var $A = $("<div><a href='javascript:void(0)'>Retirer le logo de mes mails</a></div>").appendTo($TdPub)
                $A.on("click", function (e) {
                    $("<div/>").appendTo("body").dxCtrlAchatPopup({
                        bddCtrl: option.bddCtrl,
                        typeProduit: "pub_email",
                        onPaiement: function () {
                            option.bddCtrl.objCptCli.data.date_fin_email_pub = (new Date()).addMonths(12)
                            mConstruit()
                        }
                    })
                })
            }
            var $TdPub = $("<td style='width:1px;padding-left:5px;'/>").appendTo($Tr)
            $("<img src='" + parametre.urldispatch + "/img/logo/" + parametre.code_appli + "_pubemail30.png' style='height:30px;opacity:0.8;' alt='Sent with " + parametre.nom + "'/>").appendTo($TdPub)
        }

        if (option.type == "email") {
            //gestion domaine dédié
            if (option.data.email_expediteur != null && option.data.email_expediteur.length > 0) {
                if (option.bddCtrl.objCptCli.objetMetier.hasOptionDomaineDedie()) {
                    //on a l'option domaine dédié
                    var $DivDomaineDedie = $("<div/>").appendTo($Td)
                    option.bddCtrl.mAjaxCall({ command: "isemailfromfai", adresse_email: option.data.email_expediteur }, function (data) {
                        if (data.isfromfai == "1") {
                            $("<div style='text-align:right;padding:5px 0;color:orange;' class='state-hover'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Votre email d'expediteur <u>" + option.data.email_expediteur + "</u> est un email gratuit. Nous vous recommandons d'utiliser un email lié à un de vos domaines dédiés.</div>").appendTo($DivDomaineDedie).on("click", function () {
                                option.onDemandeExpediteur()
                            })
                        } else {
                            var currentDomaine = option.data.email_expediteur.split("@")[1]
                            option.bddCtrl.mAjaxCall({ command: "getlstdomainededie" }, function (data) {
                                if (typeof data.lst_domaine == 'undefined') data.lst_domaine = []
                                if (data.lst_domaine.filter(function (o) { return o.domaine == currentDomaine }).length > 0) {
                                    //le domaine du mail est dans les domaines dédié
                                    option.bddCtrl.mAjaxCall({
                                        command: "getdnsdomaineverif",
                                        domaine: currentDomaine
                                    }, function (data) {
                                        if (data.lstdns.filter(function (dns) {
                                            return dns.current_value != dns.data.substring(0, dns.data.length - 1)
                                        }).length == 0) {
                                            $("<div style='text-align:right;padding:5px 0;color:green;'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Votre email d'expediteur <u>" + option.data.email_expediteur + "</u> est un email professionnel lié à un de vos domaines dédiés.</div>").appendTo($DivDomaineDedie)
                                        } else {
                                            $("<div style='text-align:right;padding:5px 0;color:orange;' class='state-hover'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Votre email d'expediteur <u>" + option.data.email_expediteur + "</u> est un email professionnel lié à un de vos domaines dédiés. Ce domaine dédié n'est pas correctement configuré. Cliquez pour le configurer.</div>").appendTo($DivDomaineDedie).on("click", function (e) {
                                                var popupDns = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                                    fullScreen: false,
                                                    showMaximize: false,
                                                    title: "Vérifier les DNS",
                                                    height: "auto",
                                                    maxHeight: "100%",
                                                    width: 750,
                                                    contentTemplate: function (contentElement) {
                                                        contentElement.css("padding-top", "0px")
                                                        var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                                                        $("<div style='height:100%;min-height:200px;'/>").appendTo(dxScroll.content()).dxCtrlDomaineDedieDns({
                                                            bddCtrl: option.bddCtrl,
                                                            domaine: currentDomaine
                                                        }).dxCtrlDomaineDedieDns("instance")
                                                    },
                                                    onHiden: function (e) {
                                                        mConstruit()
                                                    }
                                                }).dxCtrlPopupBase("instance")
                                                popupDns.show()
                                            })
                                        }
                                    })
                                } else {
                                    //le domaine du mail n'est pas dans les domaines dédié
                                    $("<div style='text-align:right;padding:5px 0;color:orange;' class='state-hover'><i class='fas fa-thumbs-up' style='font-size:140%;padding-right:0px;'></i> Le domaine de votre email d'expediteur <u>" + option.data.email_expediteur + "</u> est un email professionnel qui ne fait pas partie de vos domaine dédié. Nous vous recommandons d'utiliser une adresse email lié à un de vos domaines dédiés que vous avez configuré.</div>").appendTo($DivDomaineDedie).on("click", function () {
                                        option.onDemandeExpediteur()
                                    })
                                }
                            })
                        }
                    })
                }
            }
        }


        var $DivResume = $("<div style='text-align:right;padding:5px 0;'>Vous disposez de <b>" + nbCreditDispo + " crédits</b> pour votre envoi.</div>").appendTo($Td)
        if (nbTotalCredit > nbCreditDispo) {
            envoiKoMessage += (envoiKoMessage.length > 0 ? ",<br/>" : "") + "&bull; Vous ne disposez pas de suffisament de crédits pour votre envoi"
            var nbManque = nbTotalCredit - nbCreditDispo
            $("<div style='text-align:right;color:red;font-weight:bold;'>Vous ne disposez pas de suffisament de crédits pour votre envoi. (il vous manque " + nbManque + " crédits).</div>").appendTo($DivResume)
            var $Div = $("<div style='text-align:right;'></div>").appendTo($DivResume)
            var $A = $("<a href='javascript:void(0)'>Acheter des crédits</a>").appendTo($Div)
            $A.on("click", function () {
                $("<div/>").appendTo("body").dxCtrlAchatPopup({
                    bddCtrl: option.bddCtrl,
                    typeProduit: ((option.type == "email") ? "credit_email" : "credit_sms"),
                    nb: ((option.type == "email") ? 1000 : 5),
                    onPaiement: function () {
                        jaugeDemarrage.mShow()
                        option.bddCtrl.mReloadTable(((option.type == "email") ? "credit_email" : "credit_sms"), function () {
                            mConstruit()
                            jaugeDemarrage.mHide()
                        })
                    }
                })
            })
        } else {
            //$DivResume.css("color", "darkgreen")
        }

        //ajout stop
        if (option.type == "sms") {
            var $TableStop = $("<table style='width:100%'/>").appendTo($Td)
            var $TrStop = $("<tr/>").appendTo($TableStop)
            var $TdStop = $("<td style='width:100%;text-align:right;'>Ajouter un <b>STOP</b> de désinscription<br/>à mes messages</td>").appendTo($TrStop)
            var $TdStop = $("<td style='width:1px;padding:10px 0 10px 10px;'></td>").appendTo($TrStop)
            $("<div/>").appendTo($TdStop).dxCtrlCheckBox({
                value: (option.data.ajout_stop == "1"),
                onValueChanged: function (e) {
                    option.data.ajout_stop = ((e.value) ? "1" : "0")
                    option.bddCtrl.getObjet(option.data).mSaveChamp("ajout_stop")
                    if (typeof option.onChangeAjoutStop != 'undefined') option.onChangeAjoutStop()
                }
            })
        }

        $("<br/>").appendTo($DivResume)
        $("<div style='display:inline-block;margin-top:10px;'/>").appendTo($DivResume).dxCtrlButton({
            text: "Envoyer",
            onClick: function (e) {
                if (envoiKoMessage.length > 0) {
                    var ttenvoiKo = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: e.component.element(),
                        position: "top",
                        width: 350,
                        showCloseButton: false,
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding", "15px")
                            contentElement.css("text-align", "left")
                            contentElement.css("white-space", "normal")
                            contentElement.html("<div><span style='color:orange;font-size:120%;'>Impossible d'envoyer votre message</span><br/>" + envoiKoMessage + "</div>")
                        }
                    }).dxCtrlTooltip("instance")
                    ttenvoiKo.show()
                } else {
                    if (option.type == "sms") {
                        //verif stop
                        var txtMessageSms = ""
                        var txtBt = ""
                        if (option.data.ajout_stop == "1") {
                            //STOP ACTIVE. message cadencement horaire
                            txtMessageSms = "Vous avez activé le lien de désinscription sur vos messages.<br/>vos envois auront lieu entre 8h et 20h<br/>du lundi au samedi hors jours fériés."
                            txtBt = "J'ai compris"
                        } else {
                            //STOP DESACTIVE
                            if (option.clComDest.mGetLstDestComNettoyer().length <= 0) {
                                //on ne dit rien si moins de 50 destinataires
                                mExeEnvoi()
                                return
                            } else {
                                //on prévient que c'est mal
                                txtMessageSms = "Vous n'avez pas demandé l'ajout d'un lien de désinscription.<br/>Nous vous rappellons que tout sms commercial doit donner la possibilité à vos destinataires de se désinscrire via un lien <b>STOP</b>.<br/>En cas d'abus, votre compte pourra être suspendu."
                                txtBt = "Ce n'est pas un SMS commercial"
                            }
                        }
                        if (txtMessageSms.length > 0) {
                            var ttConfirm = $("<div/>").appendTo("body").dxCtrlTooltip({
                                target: e.component.element(),
                                position: "top",
                                width: 350,
                                showCloseButton: false,
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "15px")
                                    contentElement.css("white-space", "normal")
                                    $("<div style='padding:10px;'/>").appendTo(contentElement).html(txtMessageSms)
                                    $("<div style='display:inline-block;margin-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                        html: txtBt + "<br>Envoyer",
                                        width: 300,
                                        onClick: function (e) {
                                            ttConfirm.hide()
                                            mExeEnvoi()
                                        }
                                    })
                                }
                            }).dxCtrlTooltip("instance")
                            ttConfirm.show()
                        }
                    } else { mExeEnvoi() }
                }

                function mExeEnvoi() {
                    option.jauge.mShow()
                    option.data.nb_credit_par_message = nbCredit
                    option.data.tracking = "1"
                    option.data.heberger_image = "1"
                    //if (typeof option.onDemandeEnvoi != 'undefined') { option.onDemandeEnvoi(function () { mNettoie() }) }
                    //else { mNettoie() }
                    //function mNettoie() {
                    //nettoyage
                    if (option.clComDest.mGetLstDestCom().length != option.clComDest.mGetLstDestComNettoyer().length) {
                        option.clComDest.mNettoieListeNoireETIdentiqueETDoublonETSansAdresseETHardBounceAndSave(function () { mSend() })
                    } else { mSend() }
                    //}
                    function mSend() {
                        if (parametre.code_appli == "ppmasc" || option.bddCtrl.nom_base.endsWith("_aagest")) {
                            //avec rgpd
                            mSend2()
                        } else {
                            if (option.type == "email") {
                                option.bddCtrl.mAjaxCall({
                                    command: "gethtmlurldataemailbdd",
                                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                                    id: option.bddCtrl.getObjet(option.data).cle()
                                }, function (data) {
                                    if (data.html.contains("{LIEN_DESINSCRIPTION}")) {
                                        mSend2()
                                    } else {
                                        //on a pas de lien de désincription
                                        option.jauge.mHide()
                                        mConfirmTooltip(e.component.element(), "<span style='color:red;font-size:200%;'>⚠</span> ATTENTION <span style='color:red;font-size:200%;'>⚠</span><br/><br/>Vous n'avez pas mis de lien de désinscription<br/>Cela peut-être une source de mise en SPAM et peut affecter votre délivrabilité<br/>Rappel: tous les messages publicitaires doivent comporter un lien de désinscription.<br/>(En cas d'abus ou de plainte, vos envois pourraient-être suspendus)<br/><br/>Nous vous recommandons d'ajouter un lien de désinscription<br/><a href='" + parametre.url_cognoss + "/0/83/Lien_de_desinscription_et_de_navigation/bc' target='_blank'>Comment ajouter un lien de désinscription</a><br/><br/>Confirmez l'envoi sans lien de désinscription ?", function () { mSend2() })
                                    }
                                })
                            } else { mSend2() }
                        }


                        function mSend2() {
                            option.jauge.mShow()
                            option.bddCtrl.getObjet(option.data).objetMetier.mSend(function () {
                                page.mRemovePopup(option.data)
                                window.setTimeout(function () {
                                    if (option.type == "sms") {
                                        option.bddCtrl.getObjet("com_sms_envoi", option.data.id_com_sms_envoi).mShowPopup()
                                    } else {
                                        option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi).mShowPopup()
                                    }
                                }, 250)
                                option.jauge.mHide()
                            })
                        }
                    }
                }

            }
        })
    }

    //si on a mis a jour le contenu du mail ou du sms
    this.mUpdate = function () {
        mConstruit()
    }

    this.element = function () { return container }

    mConstruit();
}